import { memo } from 'react';
import { ArrangementCard } from './ArrangementCard';

// type Listname = "A Cappella/Choir" | "Solo Piano" | "Transcription"

const ArrangementCardList = ({ products, pauseAllMedia, listName }) => {
  return products.map((product, idx) => {
    return <ArrangementCard
      key={product.id}
      listName={listName}
      positionNumber={idx}
      type={product.type}
      pauseAllMedia={pauseAllMedia}
      item={product}
      src={`/static/img/coverImages/${product.artfile}`}
      alt={product.title}
    />
  });
}

export default memo(ArrangementCardList);